module.exports = __webpack_public_path__ + "static/img/bg-ar.f4317bfb.png";